
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(6(456|780|922)|18(04|26|82|89)|8(4|441|51)|7((32|58|65)6|574|703)|3(00[27]|317|390)|2237|2820|4399|5870|9043|9783)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
